import React, { useEffect, useState } from "react";
import styles from "./styles/Demo.module.css";
import { useNavigate } from "@tanstack/react-router";
import useWindowWidth from "@shared/hooks/useWindowWidth";

const MOBILE_BREAKPOINT = 768; // Определяем breakpoint

const DemoMobilePage: React.FC = () => {
  const navigate = useNavigate();
  const windowWidth = useWindowWidth();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [shouldRenderMobile, setShouldRenderMobile] = useState(false);

  const slides = [
    "/landing/DemoMobile.png",
    "/landing/DemoMobile2.png",
  ];

  useEffect(() => {
    if (windowWidth === 0) { // Начальное значение, ждем актуальную ширину
      setShouldRenderMobile(false); // Пока не рендерим, или можно иметь состояние isLoading
      return;
    }

    if (windowWidth > MOBILE_BREAKPOINT) {
      navigate({ to: "/demo", replace: true });
      setShouldRenderMobile(false); // Не рендерить мобильную, т.к. будет редирект
    } else {
      setShouldRenderMobile(true); // Рендерить мобильную версию
    }
  }, [windowWidth, navigate]);

  const goToNextSlide = () => {
    setCurrentSlide(1);
  };

  // Если еще не определено, рендерить мобильную или нет, показываем заглушку
  // Это помогает избежать "мигания" мобильного контента перед редиректом
  if (!shouldRenderMobile && windowWidth > MOBILE_BREAKPOINT && windowWidth !==0) {
      // Эта ветка нужна, чтобы компонент не пытался отрендерить мобильный контент,
      // пока navigate() еще не завершил свою работу, если условие редиректа уже выполнено.
      return null; // Или <PageLoader />
  }
  
  if (!shouldRenderMobile && windowWidth === 0) {
      return null; // Еще не знаем ширину
  }

  // Если мы здесь, значит, shouldRenderMobile === true, и это точно мобильное устройство (или узкое окно)
  return (
    <div className={styles.demoMobileContainer} style={{ backgroundImage: `url(${slides[currentSlide]})` }}>
      {currentSlide === 0 && (
        <>
          <button
            onClick={goToNextSlide}
            className={styles.demomButton1} // Убедитесь, что стили существуют
          >
            <img
              src="/landing/Premier.svg"
              alt="Кнопка 1"
              width="100%"
              height="100%"
            />
          </button>
          <button
            onClick={goToNextSlide} // Возможно, здесь должна быть другая логика для второй кнопки?
            className={styles.demomButton2} // Убедитесь, что стили существуют
          >
            <img
              src="/landing/Fesit.svg"
              alt="Кнопка 2"
              width="100%"
              height="100%"
            />
          </button>
        </>
      )}

      {currentSlide === 1 && (
        <>
          <button
            onClick={() => window.location.href = "https://discord.gg/Ypeb4etKrX"}
            className={styles.demomButton3} // Убедитесь, что стили существуют
          >
            <img
              src="/landing/ToDiscord.svg"
              alt="Кнопка Назад/Discord"
              width="100%"
              height="100%"
            />
          </button>
        </>
      )}
    </div>
  );
};

export default DemoMobilePage;
